import makeStyles from "@mui/styles/makeStyles";
import { polyfillCSS } from "../../utils/css";

export const exerciseDrawerStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    zIndex: "99999 !important" as any,
  },

  paper: {
    padding: theme.spacing(3, 4),
    paddingTop: polyfillCSS(
      `calc(var(--safe-area-inset-top) + ${theme.spacing(1)})`,
    ),
    width: "100%",
    backgroundImage: "none",

    "& h2": {
      fontSize: 32,
      margin: theme.spacing(2, 0),
    },

    [theme.breakpoints.up("md")]: {
      maxWidth: theme.spacing(65),
      minWidth: theme.spacing(50),
      width: theme.spacing(65),
      boxShadow: theme.shadows[8],
    },
  },

  header: {
    margin: theme.spacing(0, 0, 3, 0),
  },

  buttons: {
    display: "flex",
    alignItems: "center",

    "& > :last-child": {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center",
    },
  },

  title: {
    marginBottom: theme.spacing(2),
    cursor: "pointer",
  },

  titleText: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: "32px",
  },

  headerButton: {
    color: theme.palette.primary.main,
    borderRadius: 4,
    fontSize: 16,
    fontWeight: 500,

    "& svg": {
      width: 24,
      height: 24,
    },
  },

  deleteButton: {
    color: theme.palette.error.light,
  },

  backButton: {
    marginLeft: theme.spacing(-2),
  },

  closeButton: {
    marginRight: theme.spacing(-2),
  },

  addButton: {
    borderRadius: 4,
    borderStyle: "solid",
    borderColor: theme.palette.text.secondary,
    fontSize: 16,
    fontWeight: "bold",
    padding: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
}));
